import { render } from "./PublicationDigitalProducts.vue.js?vue&type=template&id=b7ba824e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDigitalProducts.vue?vue&type=template&id=b7ba824e"
import script from "./PublicationDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDigitalProducts.vue?vue&type=script&lang=js"
export * from "./PublicationDigitalProducts.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDigitalProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationDigitalProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7ba824e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7ba824e', __exports__)) {
    api.reload('b7ba824e', __exports__)
  }
  
  module.hot.accept("./PublicationDigitalProducts.vue.js?vue&type=template&id=b7ba824e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationDigitalProducts.vue?vue&type=template&id=b7ba824e", () => {
    api.rerender('b7ba824e', render)
  })

}


export default __exports__